module.exports = __webpack_public_path__ + "static/media/ic-editor-color.02f7d1c3.svg";